// Date型からinputのdatetime-local形式に変換（時差を考慮）
export const dateToDatetimeLocal = (date) => {
    const dateObj = new Date(date);
    const localDate = new Date(dateObj.getTime() + 9 * 60 * 60 * 1000); // JSTに変換
    return localDate.toISOString().slice(0, 16); // YYYY-MM-DDTHH:mm形式に変換
}

// datetime-local形式の文字列に時間差(ミリ秒)を加算する。
// valueが未設定なら""、パースできない不正な値ならnullを返す（呼び出し側でスキップ判定するため）
export const shiftDatetimeLocal = (value, timeDiffMs) => {
    if (!value) return "";
    const shifted = new Date(new Date(value).getTime() + timeDiffMs);
    if (isNaN(shifted.getTime())) return null;
    return dateToDatetimeLocal(shifted);
}
